import { apiRequest } from './http';
import type { GenerationResult, PropertyPreviewResult, TemplateChoice, TemplateForm } from './types';

export async function listAvailableTemplates(language?: string, country?: string): Promise<TemplateChoice[]> {
  const params = new URLSearchParams();
  if (language !== undefined) params.set('language', language);
  if (country !== undefined) params.set('country', country);
  const query = params.toString();
  const response = await apiRequest<{ items?: TemplateChoice[] }>(`/api/templates${query ? `?${query}` : ''}`);
  return response.items ?? [];
}

/** Defaults are resolved server-side (DC-12), so the wizard renders what generation will use. */
export async function getTemplateForm(templateId: string): Promise<TemplateForm> {
  return apiRequest<TemplateForm>(`/api/templates/${encodeURIComponent(templateId)}/form`);
}

/** A signed-in-only "preview" twin of the admin Test Service call — for a `source: service`
 * property, resolves its `inputValues` against the wizard's own current values and actually
 * calls the configured service, so the wizard can show what generation would produce. */
export async function previewServiceProperty(
  templateId: string,
  tokenName: string,
  values: Record<string, string>
): Promise<PropertyPreviewResult> {
  return apiRequest<PropertyPreviewResult>(
    `/api/templates/${encodeURIComponent(templateId)}/properties/${encodeURIComponent(tokenName)}/preview`,
    {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ values })
    }
  );
}

export async function generateDocument(
  templateId: string,
  properties: Record<string, string>,
  dryRun: boolean,
  elapsedSeconds?: number
): Promise<GenerationResult> {
  return apiRequest<GenerationResult>('/api/documents/generate', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ templateId, properties, dryRun, elapsedSeconds })
  });
}
